if (window.localStorage.quizKitResultsProducts) {
  const parsedHTML = JSON.parse(window.localStorage.quizKitCustomerCompletions);
  console.log(parsedHTML)
  const currentProducts = parsedHTML['d1gdvUUO8']['recommendedProducts'];

  setProperty();

  function setProperty() {
    const $haeader = $('header.header');

    setTimeout(() => {
      document.documentElement.style.setProperty('--header-height', $haeader.outerHeight() + 'px');
    },200);
  }

  const amountProductPerLine = currentProducts.length >= 4 ? 4 : 3;

  document.documentElement.style.setProperty('--product-per-line', amountProductPerLine );

  let containerForProductList = $('.quiz-kit__product-result-inner--list'),
      containerSingleProductBlockInner = $(".quiz-kit__product-result--single .quiz-kit__product-result-inner--single"),
      containerForSingleProduct = $(".quiz-kit__product-result-inner--single"),
      otherProductsArray = [];

  const promises = currentProducts.map((item) => {
    return new Promise((resolve, reject) => fetch(`/products/${item.handle}?variant=${item.variants[0].id}&view=quiz-kit-result-6`, {
        credentials: 'same-origin',
        method: 'GET'
      })
        .then((response) => response.text())
        .then(function(response) {
          const DOMElement = new DOMParser().parseFromString(response, "text/html");
          const productCard = DOMElement.body.querySelector("li");

          resolve(productCard);
        })
    )
  });

  $(document).on('click', '.quiz-kit__product-result-inner .product-grid-item .quick-add__submit', function (e) {
    e.preventDefault();
    const $select = $(this).parents('form[action="/cart/add"]').find('[data-product-select]');
    const $cardWrapper = $(this).parents('.quiz-kit__product-wrapper').find('.quiz-kit__product-summary-cart');
    const cardButton = $(this).parents('.quiz-kit__product-wrapper').find('.quiz-kit__product-summary-cart-item-button');
    const cardButtonCount = cardButton.find('.products-count');
    const cardButtonPrice = cardButton.find('.products-price');

      //----change product to checked and change btn label to remove
      ($select.attr('data-product-select') === 'true') ? $select.attr('data-product-select', 'false') : $select.attr('data-product-select', 'true');
      ($(this).attr('data-label-remove') === 'true') ? $(this).attr('data-label-remove', 'false') : $(this).attr('data-label-remove', 'true');

      const $productSelected = $('[data-product-select="true"]');
      const $optionSelected = $productSelected.find('option[selected]');

      let sumPrice = 0;
      //----create and append html to summary bag
      let resultHTML = Array.from($optionSelected).map(function(elem, index) {
        const title = elem.getAttribute('data-product-title');
        const price = elem.getAttribute('data-variant-price') / 100;
        const variantId = elem.value;
        sumPrice =  price + sumPrice;

        return '<div class="quiz-kit__product-summary-cart-item bundle" data-property="6558" data-variant-id="'+variantId+'"><span class="quiz-kit__product-summary-cart-item-title">'+ title +'</span><span class="quiz-kit__product-summary-cart-item-price">' + '$' + price +'</span></div>';
      });
      if(resultHTML.length) {
        document.querySelector('.not-ready-commit').style.display = 'block';
      } else {
        document.querySelector('.not-ready-commit').style.display = 'none';
      }
      $cardWrapper.html(resultHTML);
      cardButtonCount.html((resultHTML.length > 1) ? resultHTML.length+' Items' : resultHTML.length+' Item');
      cardButtonPrice.html('$' + sumPrice);
      (resultHTML.length > 0) ? cardButton.attr('aria-hidden', 'false') : cardButton.attr('aria-hidden', 'true');
  });

  function sendDataToQuizkitapp($optionSelected) {

      Array.from($optionSelected).forEach((elem) => {
        let variantId = $(elem).parents('form[action="/cart/add"]').find('[data-product-select]').val();

        console.log(variantId, 'variantId')

        $.ajax({
          type: 'POST',
          data: JSON.stringify({price: $(elem).attr('data-variant-price'), variantId: parseInt(variantId, 10)}),
          url: 'https://api.quizkitapp.com/api/v1/quizzes/d1gdvUUO8/add-to-cart',
          dataType: 'json',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
      })
  }

  $('.quiz-kit__product-summary-cart-item-button').on('click', function (e) {
    const $optionSelected = $('[data-product-select="true"] option[selected]');

    sendDataToQuizkitapp($optionSelected);

    // Array.from($optionSelected).forEach((elem) => {
    //   let variantId = $(elem).parents('form[action="/cart/add"]').find('[data-product-select]').val();
    //
    //   $.ajax({
    //     type: 'POST',
    //     data: JSON.stringify({price: $(elem).attr('data-variant-price'), variantId: parseInt(variantId, 10)}),
    //     url: 'https://api.quizkitapp.com/api/v1/quizzes/d1gdvUUO8/add-to-cart',
    //     dataType: 'json',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'X-Requested-With': 'XMLHttpRequest'
    //     }
    //   });
    // })
  });

  $('.quiz-kit__product-summary-cart-item-button--add-all').on('click', function (e) {
    const $optionSelected = $('[data-product-select] option[selected]');

    sendDataToQuizkitapp($optionSelected);
  });
}

